export default __webpack_public_path__ + "static/media/02_gallery.63ef9e05.jpg";